mutation RetryDomainSetup {
  retryDomainSetup {
    id
    host
    domainSetup {
      host
      status
      zoneName
      lastError
      updatedAt
      activatedAt
    }
  }
}
